import {NgModule} from '@angular/core';
import {AngularResizeElementDirective} from './angular-resize-element.directive';

@NgModule({
    declarations: [AngularResizeElementDirective],
    imports: [],
    exports: [AngularResizeElementDirective]
})
export class AngularResizeElementModule { }
